import { useQuery } from "react-query";
import { useParams } from "react-router-dom";

import { showCategories } from "../../../../MyApi/sb/categories";

import LoadingSpinner from "../../../../Components/UI/spinner";
import PageHeader from "../../../../Components/UI/PageHeader";
import CategoryDetalis from "../../../../Components/sb/categories/categoriesShow/companyDetalis";


const CategoriesShow = () => {
  const { id } = useParams();
  const { data, isLoading } = useQuery(["showCategories", id], () =>
    showCategories(id)
  );
  const categories = data?.data || {};

  if (isLoading) {
    return <LoadingSpinner />;
  }
  if (!data) {
    return <div>no data available</div>;
  }
  return (
    <div>
      <PageHeader title="categories Detalis" showBack={true} />
      <CategoryDetalis categories={categories} />
    </div>
  );
};

export default CategoriesShow;
